<template>
  <v-snackbar
    v-model="isSnackbarVisible"
    :color="snackbarColor"
    top
    right
    timeout="6000"
    @input="onSnackbarClose"
  >
    {{ snackbarMessage }}
    <v-btn color="white" text @click="closeSnackbar">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    snackbarMessage() {
      return this.$store.state.snackbarMessage;
    },
    snackbarColor() {
      return this.$store.state.snackbarColor;
    },
    isSnackbarVisible: {
      get() {
        return this.$store.state.isSnackbarVisible;
      },
      set(value) {
        if (!value) this.closeSnackbar();
      },
    },
  },
  methods: {
    closeSnackbar() {
      this.$store.commit("hide_snackbar");
    },
    onSnackbarClose() {
      this.closeSnackbar();
    },
  },
};
</script>
